import { render, staticRenderFns } from "./les-criteres-essentiels-pour-choisir-un-bon-hebergement-web.vue?vue&type=template&id=35ee20a4&"
import script from "./les-criteres-essentiels-pour-choisir-un-bon-hebergement-web.vue?vue&type=script&lang=js&"
export * from "./les-criteres-essentiels-pour-choisir-un-bon-hebergement-web.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports